var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcommEliteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 20,
    viewBox: "0 0 53 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.207182,
    y: 0.207182,
    width: 51.9448,
    height: 19.5856,
    rx: 9.79282,
    fill: "url(#paint0_linear_260_57)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.207182,
    y: 0.207182,
    width: 51.9448,
    height: 19.5856,
    rx: 9.79282,
    stroke: "url(#paint1_linear_260_57)",
    strokeWidth: 0.414365
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04045 12.2278L5.92627 6.09981L8.99027 8.88527L10.9401 5.54272L12.8899 8.88527L15.9539 6.09981L14.8397 12.2278H7.04045ZM14.8397 13.8991C14.8397 14.2333 14.6169 14.4562 14.2826 14.4562H7.59754C7.26329 14.4562 7.04045 14.2333 7.04045 13.8991V13.342H14.8397V13.8991Z",
    fill: "url(#paint2_linear_260_57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0737 14V6.92818H24.8389V8.16091H21.5689V9.84599H24.5937V11.0787H21.5689V12.7673H24.8527V14H20.0737ZM26.0276 14V6.92818H27.5228V12.7673H30.5545V14H26.0276ZM33.0399 6.92818V14H31.5447V6.92818H33.0399ZM34.0007 8.16091V6.92818H39.8087V8.16091H37.6436V14H36.1657V8.16091H34.0007ZM40.7652 14V6.92818H45.5304V8.16091H42.2603V9.84599H45.2852V11.0787H42.2603V12.7673H45.5442V14H40.7652Z",
    fill: "#EAC576"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_260_57",
    x1: 40.7238,
    y1: 23.7143,
    x2: -166.221,
    y2: -106.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#424242",
    stopOpacity: 0.818492
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_260_57",
    x1: -3.42452,
    y1: 0.00000335215,
    x2: 55.1382,
    y2: 11.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490463,
    stopColor: "#ECC779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966C10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_260_57",
    x1: 5.27042,
    y1: 5.54273,
    x2: 16.8543,
    y2: 6.5452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490463,
    stopColor: "#ECC779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966C10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommEliteLogo);
export default __webpack_public_path__ + "static/media/ecommEliteLogo.fde0035cab20a8a0f45bd88e648665d6.svg";
export { ForwardRef as ReactComponent };